import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { transaction } from '@datorama/akita';
import { CookieService } from 'ngx-cookie-service';
import { AuthRedirectService } from '../../services/auth-redirect.service';
import { SessionStore } from './session.store';
import { environment } from '@env/environment';
import { SessionQuery } from './session.query';
import { from, throwError, timer } from 'rxjs';
import { mergeMap, retryWhen } from 'rxjs/operators';
import { KeycloakService } from 'keycloak-angular';
import { LOAD_USER_RETRY_DELAYS_MS, LOGIN_REDIRECT_KEY, LOGIN_REDIRECT_LOOP_WINDOW_MS, } from '../../constants/token-refresh.const';
var SessionService = /** @class */ (function () {
    function SessionService(sessionStore, sessionQuery, http, cookieService, authRedirectService, keycloak) {
        this.sessionStore = sessionStore;
        this.sessionQuery = sessionQuery;
        this.http = http;
        this.cookieService = cookieService;
        this.authRedirectService = authRedirectService;
        this.keycloak = keycloak;
        this.loginRedirectInProgress = false;
    }
    SessionService.prototype.saveToken = function (token) {
        this.sessionStore.update({ token: token });
        this.cookieService.set(environment.tokenKey, token, undefined, '/');
    };
    SessionService.prototype.clearToken = function () {
        this.sessionStore.update({ token: null });
        this.cookieService.delete(environment.tokenKey);
    };
    SessionService.prototype.getToken = function () {
        return this.sessionQuery.getValue().token || '';
    };
    SessionService.prototype.loadUser = function () {
        var _this = this;
        this.sessionStore.setLoading(true);
        this.http.get(environment.apiRoot + "/profiling/api/account")
            .pipe(
        // Мережеві / 5xx помилки (напр. одразу після пробудження ноутбука) — пробуємо ще раз.
        retryWhen(function (errors) { return errors.pipe(mergeMap(function (error, attempt) {
            return attempt < LOAD_USER_RETRY_DELAYS_MS.length && _this.isTransientError(error)
                ? timer(LOAD_USER_RETRY_DELAYS_MS[attempt])
                : throwError(error);
        })); }))
            .subscribe(function (user) {
            _this.clearLoginRedirectMark();
            _this.sessionStore.update({
                user: user,
                loading: false,
            });
        }, function (error) {
            console.error('[Auth] Не вдалося завантажити профіль користувача', error);
            // loading=false → AuthGuard побачить, що user відсутній, і відправить на логін.
            _this.sessionStore.setLoading(false);
        });
    };
    /**
     * Редірект на логін Keycloak без знищення SSO-сесії (на відміну від logout()).
     * Перший раз — звичайний login(): при живій сесії користувач повернеться без пароля.
     * Якщо редірект повторюється протягом LOGIN_REDIRECT_LOOP_WINDOW_MS (напр. /account постійно падає),
     * примусово показуємо форму входу, щоб не зациклити сторінку на тихих редіректах.
     */
    SessionService.prototype.redirectToLogin = function () {
        // canActivate і canActivateChild можуть викликати це одночасно — редіректимо один раз.
        if (this.loginRedirectInProgress) {
            return;
        }
        this.loginRedirectInProgress = true;
        var now = Date.now();
        var lastRedirect = Number(this.readLoginRedirectMark()) || 0;
        var isRepeated = now - lastRedirect < LOGIN_REDIRECT_LOOP_WINDOW_MS;
        this.writeLoginRedirectMark(String(now));
        this.sessionStore.update({ token: null, user: null });
        var options = { redirectUri: window.location.href };
        if (isRepeated) {
            options.prompt = 'login';
        }
        this.keycloak.login(options);
    };
    /** Явний вихід користувача (кнопка «Вийти»). Знищує SSO-сесію в Keycloak. */
    SessionService.prototype.logout = function () {
        this.clearToken();
        this.sessionStore.reset();
        return from(this.keycloak.logout());
    };
    SessionService.prototype.isTransientError = function (error) {
        return !!error && (error.status === 0 || error.status >= 500);
    };
    SessionService.prototype.readLoginRedirectMark = function () {
        try {
            return sessionStorage.getItem(LOGIN_REDIRECT_KEY);
        }
        catch (_a) {
            return null;
        }
    };
    SessionService.prototype.writeLoginRedirectMark = function (value) {
        try {
            sessionStorage.setItem(LOGIN_REDIRECT_KEY, value);
        }
        catch (_a) {
        }
    };
    SessionService.prototype.clearLoginRedirectMark = function () {
        try {
            sessionStorage.removeItem(LOGIN_REDIRECT_KEY);
        }
        catch (_a) {
        }
    };
    tslib_1.__decorate([
        transaction(),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [String]),
        tslib_1.__metadata("design:returntype", void 0)
    ], SessionService.prototype, "saveToken", null);
    return SessionService;
}());
export { SessionService };
